"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _uuid = require('shared/services/uuid');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
 const isValidAttempt = (value) =>
  typeof value === 'string' && UUID_RE.test(value); exports.isValidAttempt = isValidAttempt

const orgAttemptKey = (orgKey) => `onb_pay_attempt_${orgKey}`
const signupAttemptKey = (token) => `onb_pay_attempt_signup_${token}`

const read = (key) => {
  try {
    return sessionStorage.getItem(key) || undefined
  } catch (e) {
    return undefined
  }
}

const write = (key, value) => {
  try {
    sessionStorage.setItem(key, value)
  } catch (e2) {
    // best-effort; storage may be unavailable in private modes
  }
}

const remove = (key) => {
  try {
    sessionStorage.removeItem(key)
  } catch (e3) {
    // best-effort
  }
}

 const getStoredAttempt = (orgKey) => read(orgAttemptKey(orgKey)); exports.getStoredAttempt = getStoredAttempt
 const setStoredAttempt = (orgKey, attemptId) =>
  write(orgAttemptKey(orgKey), attemptId); exports.setStoredAttempt = setStoredAttempt
 const getOrCreateOrgAttempt = (orgKey) => {
  const stored = exports.getStoredAttempt.call(void 0, orgKey)
  if (exports.isValidAttempt.call(void 0, stored)) return stored
  const attemptId = _uuid.uuidv4.call(void 0, )
  exports.setStoredAttempt.call(void 0, orgKey, attemptId)
  return attemptId
}; exports.getOrCreateOrgAttempt = getOrCreateOrgAttempt
 const clearPaymentContinuity = (orgKey) => remove(orgAttemptKey(orgKey)); exports.clearPaymentContinuity = clearPaymentContinuity
 const hasCancelledContinuity = (orgKey, attemptId) =>
  exports.getStoredAttempt.call(void 0, orgKey) === attemptId; exports.hasCancelledContinuity = hasCancelledContinuity

 const getOrCreateSignupAttempt = (token) => {
  const stored = read(signupAttemptKey(token))
  if (exports.isValidAttempt.call(void 0, stored)) return stored
  const attemptId = _uuid.uuidv4.call(void 0, )
  write(signupAttemptKey(token), attemptId)
  return attemptId
}; exports.getOrCreateSignupAttempt = getOrCreateSignupAttempt

 const rekeySignupAttempt = (token, orgKey, attemptId) => {
  exports.setStoredAttempt.call(void 0, orgKey, attemptId)
  remove(signupAttemptKey(token))
}; exports.rekeySignupAttempt = rekeySignupAttempt

 const isAuthoritativeSettlement = (
  serverAttempt,
  urlAttempt,
) => !!urlAttempt && exports.isValidAttempt.call(void 0, urlAttempt) && serverAttempt === urlAttempt; exports.isAuthoritativeSettlement = isAuthoritativeSettlement

 const buildOnboardingReturnURL = (
  status,
  orgKey,
  attemptId,
) =>
  `${window.location.origin}/#${_routes.makeRoute.call(void 0, _routes2.default.ONBOARDING_PAYMENT, { status })}` +
  `?org=${encodeURIComponent(orgKey)}&attempt=${encodeURIComponent(attemptId)}`; exports.buildOnboardingReturnURL = buildOnboardingReturnURL
